import React, { useContext } from 'react'
import { Builder, withChildren, BuilderBlocks } from '@builder.io/react'
import AppContext from '../../context/app'

export default function Vimeo(props) {
    const MINIMUM_HEIGHT = 430
    const { children, title, id, width, height } = props
    const { clientWidth, screenHeight } = useContext(AppContext)

    const clientWiderThanVideo = clientWidth >= width
    const responsiveWidth = `${(height / width * clientWidth).toFixed(0)}px`
    const responsiveHeight =
        screenHeight < MINIMUM_HEIGHT ? MINIMUM_HEIGHT :
        screenHeight >= height ? `${height}px` :
        '75vh'

    return (
        <div
            className='position-relative overflow-hidden'
            style={{ paddingTop: clientWiderThanVideo ? responsiveWidth : responsiveHeight }}
        >
            <iframe
                src={`https://player.vimeo.com/video/${id}?muted=1&autoplay=1&loop=1&controls=0`}
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                className='position-absolute top-0'
                frameBorder="0"
                title={title}
                style={
                    clientWiderThanVideo ?
                        {
                            left: 0,
                            width: '100%',
                            height: '100%',
                        }
                        :
                        {
                            left: (clientWidth - width) / 2,
                            width,
                            height,
                        }
                }
            />
            {children && <BuilderBlocks blocks={children} />}
        </div>
    )
}

Builder.registerComponent(withChildren(Vimeo), {
    name: 'Vimeo',
    noWrap: true,
    inputs: [
        {
            name: 'title',
            type: 'string',
        },
        {
            name: 'id',
            type: 'string',
        },
        {
            name: 'width',
            type: 'number',
        },
        {
            name: 'height',
            type: 'number',
        },
    ]
})
